const filterGroupModule = {
  namespaced: true,

  state: {
    activeFilters: [],
    filterGroups: [],
  },
  getters: {
    selectedItems(state) {
      return state.filterGroups
        .map((group) => group.items.filter((item) => state.activeFilters.includes(item.id)))
        .flat();
    },
  },

  mutations: {
    updateFilters(state, item) {
      const index = state.activeFilters.indexOf(item.id);
      if (index > -1) {
        item.active = false;
        state.activeFilters.splice(index, 1);
      } else {
        item.active = true;
        state.activeFilters.push(item.id);
      }
    },
    clearFilters(state) {
      state.filterGroups.forEach((group) => group.items.forEach((filter) => (filter.active = false)));
      state.activeFilters = [];
    },
    setFilterGroups(state, groups) {
      state.filterGroups = groups;
    },
  },
};

export default filterGroupModule;
